import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
      if (!sessionId) {
        navigate("/login?auth_error=missing_session", { replace: true });
        return;
      }
      try {
        const res = await axios.get(`${API}/auth/session-data`, {
          headers: { "X-Session-ID": sessionId },
        });
        const { token, ...userData } = res.data;
        if (token) localStorage.setItem("skilmark_token", token);
        setUser(userData);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user: userData } });
      } catch (err) {
        console.error("Google login failed:", err?.response?.status, err?.response?.data || err.message);
        navigate("/login?auth_error=google_login_failed", { replace: true });
      }
    };
    processSession();
  }, [location.hash, navigate, setUser]);

  return <div className="min-h-screen bg-[#050505]" />;
};

export default AuthCallback;
